import { render, staticRenderFns } from "./SortField.vue?vue&type=template&id=74ab5d3a&scoped=true"
import script from "./SortField.ts?vue&type=script&lang=ts&external"
export * from "./SortField.ts?vue&type=script&lang=ts&external"
import style0 from "./SortField.scss?vue&type=style&index=0&id=74ab5d3a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ab5d3a",
  null
  
)

export default component.exports